import React, { Component } from 'react';
import PlanningServiceItemService from '../../../Services/PlanningServiceItemService.js';
import AuthService from '../../../Services/authService';
import ServiceItem from '../../../Domain/ServiceItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum.js';
import SLSearchParams from './SLSearchParams.js';

class ServiceList extends Component {
  static defaultProps = {
    ServiceId: 0,
    OpportunityId: 0
  };

  constructor(props) {
    super(props);

    const searchItem = new SLSearchParams();
    if (this.props.ServiceId || this.props.OpportunityId) {
      // if we are coming from the Service or Opportunity page
      searchItem.ServiceId = this.props.ServiceId;
      searchItem.OpportunityNameOrId = this.props.OpportunityId;
      searchItem.OfficeIds = [];
    } else {
      const officeId = AuthService.getInstance().GetLoggedInUser().officeId;
      searchItem.OfficeIds = [officeId];
    }

    this.state = {
      searchItem
    };

    this.startSearch = this.startSearch.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={ServiceItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={PlanningServiceItemService.GetServiceItems}
          convertDBItemsFunction={PlanningServiceItemService.ConvertDBServiceItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy='VPlanningServiceItemId'
          showSearchStrip={true}
          searchParamsType={SLSearchParams}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different ids and names...'
          errorCode='SL50'
        />
      </div>
    );
  }
}

export default ServiceList;
